<template>
  <section v-show="visible && records.length" class="recent-records">
    <h5 class="recent-records-title">Recently viewed</h5>
    <ul class="recent-records-list">
      <li
        v-for="record in records"
        :key="`${record.type}-${record.id}`"
        class="recent-records-row"
        @mousedown.prevent="goTo(record)"
      >
        <span class="recent-records-type">{{ typeLabel(record.type) }}</span>
        <span class="recent-records-label">{{ displayLabel(record) }}</span>
        <span class="recent-records-time">{{ formatViewedAt(record.viewedAt) }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
import HttpService from '@/api/HttpService';
import { getAccounTypeProperties } from '@/util';

export default {
  name: 'RecentRecords',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      records: [],
    };
  },
  beforeMount() {
    this.loadRecentRecords();
  },
  methods: {
    async loadRecentRecords() {
      try {
        const data = await HttpService.getV2('recent-records');
        this.records = Array.isArray(data) ? data : [];
      } catch (e) {
        this.records = [];
      }
    },
    typeLabel(type) {
      if (type === 'user') return 'User';
      if (type === 'account') return 'Account';
      if (type === 'note') return 'Note';
      return '';
    },
    displayLabel(record) {
      if (record.type === 'user') {
        const fullName = `${record.firstName || ''} ${record.lastName || ''}`.trim();
        return fullName ? `U${record.id} - ${fullName}` : `U${record.id}`;
      }
      if (record.type === 'account') {
        return record.accountName
          ? `A${record.id} - ${record.accountName}`
          : `A${record.id}`;
      }
      if (record.type === 'note') {
        return record.noteId || `#${record.id}`;
      }
      return '';
    },
    formatViewedAt(viewedAt) {
      if (!viewedAt) return '';
      const d = new Date(viewedAt);
      if (Number.isNaN(d.getTime())) return '';
      return d.toLocaleString();
    },
    goTo(record) {
      if (record.type === 'user') {
        this.$router.push({
          name: 'UserDetail',
          params: {
            userId: record.id,
            name: record.firstName || '',
          },
        });
        return;
      }
      if (record.type === 'account') {
        const accountTypeProps = getAccounTypeProperties(record.accountType);
        const routeName = (accountTypeProps && accountTypeProps.component) || 'AccountDetail';
        this.$router.push({
          name: routeName,
          params: {
            accountId: record.id,
            userId: record.userId,
            name: record.userFirstName || '',
          },
        });
        return;
      }
      if (record.type === 'note') {
        this.$router.push({
          name: 'NoteDetail',
          params: {
            noteId: record.id,
            userId: record.userId,
            name: record.userFirstName || '',
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.recent-records {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  margin-top: 6px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  padding: 10px 14px;
  max-height: 360px;
  overflow-y: auto;
}

.recent-records-title {
  font-size: 11px;
  color: #888;
  font-weight: 600;
  margin: 0 0 6px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.recent-records-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.recent-records-row {
  display: flex;
  align-items: center;
  padding: 8px 6px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 14px;
  color: #211915;
}

.recent-records-row + .recent-records-row {
  border-top: 1px solid #f0f0f0;
}

.recent-records-row:hover {
  background-color: #f0f7f9;
}

.recent-records-type {
  flex: 0 0 70px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #00788D;
  font-weight: 600;
}

.recent-records-label {
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recent-records-time {
  flex: 0 0 auto;
  margin-left: 12px;
  color: #888;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// RecentRecords.vue?dddff18a